module.exports = __webpack_public_path__ + "static/media/my_addresses_english.7a98d375.jpg";